import React from "react";
import { Button, Badge, Row, Col, Input } from "reactstrap";
import { SATextAreaInput } from "utils/functions";
import "../../../assets/css/admin.css";
import { formatDate, formatDateMDY } from "../../../utils/date";
import { SAUpdateBankForm } from "utils/functions";

const CustomerCard = ({
  customer,
  setCustomer,
  lockNote,
  setCustomerPlaidVerify,
  updateCustomerNotes,
  updateCardBank,
  chargebackLiability,
  cards,
  banklist,
  setBankList,
  setCustomerCards,
}) => {
  const isTransactionLookupPage = () => {
    return window.location.pathname.includes("transaction-lookup");
  };

  return (
    <>
      <Row>
        <Col lg="6" md="4">
          <h5 className="section-heading">
            {isTransactionLookupPage() ? (
              <>
                <a
                  href={`/admin/tools/customer-lookup/${customer.phone}`}
                  className="link"
                >
                  {customer.firstname} {customer.lastname}
                </a>
              </>
            ) : (
              `${customer.firstname} ${customer.lastname}`
            )}
          </h5>
        </Col>

        <Col lg="6" md="8" style={{ textAlign: "right" }}>
          <Button
            color={customer.isEnabled ? "danger" : "success"}
            onClick={() => lockNote(customer)}
            className="toggle-status-btn"
          >
            {customer.isEnabled ? "Lock" : "Enable"} Customer
          </Button>

          {!customer.plaidverified && (
            <Button
              color={"secondary"}
              onClick={() => setCustomerPlaidVerify(customer.customerid)}
              className="toggle-status-btn"
            >
              Plaid Verify
            </Button>
          )}
        </Col>
      </Row>

      <Row>
        <Col lg="12" md="12">
          <Badge
            color={customer.isEnabled ? "success" : "danger"}
            className="status-badge"
          >
            {customer.isEnabled ? "Active" : "Locked"}
          </Badge>
          <Badge
            color={customer.plaidverified ? "success" : "danger"}
            className="verification-badge"
          >
            {customer.plaidverified ? "Plaid Verified" : "Not Verified"}
          </Badge>
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">Customer ID</label>
          <Input type="text" readOnly value={customer.customerid} />
        </Col>
        <Col lg="3" md="3">
          <label className="label">Created</label>
          <Input
            type="text"
            readOnly
            value={
              customer.datetimecreated
                ? formatDate(customer.datetimecreated)
                : ""
            }
          />
        </Col>
        <Col lg="3" md="3">
          <label className="label">Updated</label>
          <Input
            type="text"
            readOnly
            value={
              customer.datetimeupdated
                ? formatDate(customer.datetimeupdated)
                : ""
            }
          />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">Phone</label>
          <Input type="text" readOnly value={customer.phone} />
        </Col>
        <Col lg="6" md="6">
          <label className="label">Email</label>
          <Input type="text" readOnly value={customer.email} />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">Address</label>
          <Input
            type="text"
            readOnly
            value={`${customer.address1} ${customer.address2}`}
          />
        </Col>
        <Col lg="6" md="6">
          <label className="label">City/State/Zip/Country</label>
          <Input
            type="text"
            readOnly
            value={`${customer.city}, ${customer.state} ${customer.zip}, ${customer.country}`}
          />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">Birthdate</label>
          <Input
            type="text"
            readOnly
            value={customer.birthdate ? formatDateMDY(customer.birthdate) : ""}
          />
        </Col>
        <Col lg="6" md="6">
          <label className="label">Gender</label>
          <Input type="text" readOnly value={customer.gender} />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="12" md="12">
          <label className="label">
            <span>Notes </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                SATextAreaInput(
                  "Update Notes",
                  "Customer notes...",
                  customer.notes ?? ""
                ).then((res) => {
                  updateCustomerNotes({
                    variables: {
                      customerid: customer.customerid,
                      notes: res,
                    },
                  }).then((res) => {
                    const status = res?.data?.adminUpdateCustomerNotes?.status;

                    if (status) {
                      setCustomer((prevState) => {
                        return {
                          ...prevState,
                          notes:
                            res.data.adminUpdateCustomerNotes.customer.notes,
                        };
                      });
                    }
                  });
                });
              }}
            >
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
            </svg>
          </label>
          <Input
            type="textarea"
            readOnly
            disabled={true}
            value={customer.notes}
          />
        </Col>
      </Row>

      {customer.locknote && (
        <Row className="info-row">
          <Col lg="12" md="12">
            <label className="label">
              <a
                className="link"
                href={`/admin/tools/locknote-lookup/${customer.phone}`}
              >
                {JSON.parse(customer.islock.toLowerCase()) ? "Lock" : "Unlock"}{" "}
                Note
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-link-45deg"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
                </svg>
              </a>
            </label>
            <Input
              type="textarea"
              readOnly
              disabled={true}
              value={customer.locknote}
            />
          </Col>
        </Row>
      )}

      {customer.transactionsCount >= 0 ? (
        <>
          <hr className="divider" />

          <Row className="info-row">
            <Col lg="4" md="4">
              <label className="label">Transactions</label>
              <Input type="text" readOnly value={customer.transactionsCount} />
            </Col>
            <Col lg="4" md="4">
              <label className="label">Amount</label>
              <Input
                type="text"
                readOnly
                value={`$${customer.totalTransactedAmount}`}
              />
            </Col>
            <Col lg="4" md="4">
              <label className="label">Cards on File</label>
              <Input type="text" readOnly value={customer.creditCardsCount} />
            </Col>
          </Row>

          {cards && cards.length > 0 && (
            <>
              <Row className="info-row">
                <Col>
                  <h6 className="section-heading" style={{ marginTop: "10px" }}>
                    Saved Cards
                  </h6>
                </Col>
              </Row>

              {cards.map((card, index) => (
                <Row className="info-row" key={index}>
                  <Col lg="6" md="6">
                    <span className="label">Last Four</span>
                    <Input type="text" readOnly value={card.lastfour} />
                  </Col>
                  <Col lg="6" md="6">
                    <span className="label">Bank </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil"
                      viewBox="0 0 16 16"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        SAUpdateBankForm(banklist).then((res) => {
                          if (res) {
                            updateCardBank({
                              variables: {
                                customerid: customer.customerid,
                                bankname: res.bankName,
                                lastfour: card.lastfour,
                              },
                            }).then((res) => {
                              const status =
                                res?.data?.adminUpdateCustomerCardBank?.status;
                              if (status) {
                                setBankList(
                                  res.data.adminUpdateCustomerCardBank.banklist
                                );
                                setCustomerCards(
                                  res.data.adminUpdateCustomerCardBank.cards
                                );
                              }
                            });
                          }
                        });
                      }}
                    >
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                    </svg>
                    <Input type="text" readOnly value={card.bank || ""} />
                  </Col>
                </Row>
              ))}
            </>
          )}

          {chargebackLiability && (
            <>
              <hr className="divider" />

              <Row className="info-row">
                <Col>
                  <h5 className="section-heading">
                    Chargeback Liability (90 days)
                  </h5>
                </Col>
              </Row>

              <Row className="info-row">
                <Col md="6">
                  <label className="label">Total Transactions</label>
                  <Input
                    type="text"
                    readOnly
                    value={chargebackLiability.numberOfLiability}
                  />
                </Col>
                <Col md="6">
                  <label className="label">Total Amount</label>
                  <Input
                    type="text"
                    readOnly
                    value={`$${chargebackLiability.liabilityAmount}`}
                  />
                </Col>
              </Row>

              <hr className="divider" />

              <Row className="info-row">
                <Col>
                  <h5 className="section-heading">
                    Chargeback Disputed (In Process)
                  </h5>
                </Col>
              </Row>

              <Row className="info-row">
                <Col md="6">
                  <label className="label">Total Transactions</label>
                  <Input
                    type="text"
                    readOnly
                    value={chargebackLiability.numberOfDisputed}
                  />
                </Col>
                <Col md="6">
                  <label className="label">Total Amount</label>
                  <Input
                    type="text"
                    readOnly
                    value={`$${chargebackLiability.disputedAmount}`}
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default CustomerCard;
